// extracted by mini-css-extract-plugin
export default {"mobileBlock":"MobileBlock_mobileBlock__Jfmvk"};